import { useEffect } from "react";
import { getPageTitle } from "./pageTitle.utils";

type PageTitleProps = {
  title?: string;
};

export const PageTitle = ({ title }: PageTitleProps) => {
  useEffect(() => {
    document.title = getPageTitle({ title });
  }, [title]);

  return null;
};
